module.exports = __webpack_public_path__ + "assets/img/4816f73718331345e75bc471c813f9b4.svg";